export default __webpack_public_path__ + "static/media/Bond of the Champion of Cimmeria.e588a9d5.jpg";